import { render, staticRenderFns } from "./BuildingBasic.vue?vue&type=template&id=b41b4136&scoped=true"
import script from "./BuildingBasic.vue?vue&type=script&lang=js"
export * from "./BuildingBasic.vue?vue&type=script&lang=js"
import style0 from "./BuildingBasic.vue?vue&type=style&index=0&id=b41b4136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41b4136",
  null
  
)

export default component.exports